import { privateApi } from 'services';

const updateManagedSocialCampaignStatus = async (
    brandsCampaignId: string,
    managedSocialCampaignId: string,
    running: boolean,
): Promise<void> =>
    privateApi.put<void>(
        `published-brands-campaigns/${brandsCampaignId}/managed-social-campaigns/${managedSocialCampaignId}/status`,
        {
            running,
        },
    );

export const BrandsManagedSocialCampaignGateway = {
    updateManagedSocialCampaignStatus,
};
